export class StoreProfileApi {
    client;
    constructor(client) {
        this.client = client;
    }
    lid(locationId) {
        return encodeURIComponent(locationId);
    }
    /** Publish a storefront profile (draft by default; revision 1). A concurrent create for the location → 409. */
    publish(input) {
        return this.client.request({ method: 'POST', path: '/v1/store-profile/profiles', body: input, auth: true });
    }
    /** Transition the coarse publication status (publish/delist/relist). An illegal edge → 409. */
    transitionStatus(locationId, to) {
        return this.client.request({ method: 'POST', path: `/v1/store-profile/profiles/${this.lid(locationId)}/status`, body: { to }, auth: true });
    }
    /** Temporarily pause the store (reason + strictly-future ISO expiry). Already paused → 409; bad input → 400. */
    pause(locationId, reasonCode, expiresAt) {
        return this.client.request({ method: 'POST', path: `/v1/store-profile/profiles/${this.lid(locationId)}/pause`, body: { reasonCode, expiresAt }, auth: true });
    }
    /** Clear a pause back to open. Not paused → 409. */
    resume(locationId) {
        return this.client.request({ method: 'POST', path: `/v1/store-profile/profiles/${this.lid(locationId)}/resume`, body: {}, auth: true });
    }
    /** Flag the store as busy (manual overload stop). Already busy / currently paused → 409. */
    markBusy(locationId) {
        return this.client.request({ method: 'POST', path: `/v1/store-profile/profiles/${this.lid(locationId)}/busy`, body: {}, auth: true });
    }
    /** D394: clear the manual busy flag back to open (a paused store is resumed with `resume`). Not busy → 409. */
    clearBusy(locationId) {
        return this.client.request({ method: 'POST', path: `/v1/store-profile/profiles/${this.lid(locationId)}/clear-busy`, body: {}, auth: true });
    }
    /** Replace the regular weekly schedule. Invalid geometry → 400. */
    setHours(locationId, hours) {
        return this.client.request({ method: 'PUT', path: `/v1/store-profile/profiles/${this.lid(locationId)}/hours`, body: hours, auth: true });
    }
    /** Replace prep capacity. Invalid shape → 400. */
    setCapacity(locationId, capacity) {
        return this.client.request({ method: 'PUT', path: `/v1/store-profile/profiles/${this.lid(locationId)}/capacity`, body: capacity, auth: true });
    }
    /** Replace the served geofence list. */
    setServiceArea(locationId, serviceArea) {
        return this.client.request({ method: 'PUT', path: `/v1/store-profile/profiles/${this.lid(locationId)}/service-area`, body: serviceArea, auth: true });
    }
    /** Read one storefront profile + its revision (404 when no profile has been published for the location). */
    getProfile(locationId) {
        return this.client.request({ method: 'GET', path: `/v1/store-profile/profiles/${this.lid(locationId)}`, auth: true });
    }
    /**
     * W8-MERCHANT-KITCHEN (D447, M-26/M-02): what the partner desk decides about this store NOW — the desk's own store gate
     * (platform status, pickup point, published profile, hours in the market zone, pause, busy, capacity).
     */
    orderability(locationId) {
        return this.client.request({ method: 'GET', path: `/v1/store-profile/profiles/${this.lid(locationId)}/orderability`, auth: true });
    }
    /** List every storefront under a merchant, newest first. */
    listByMerchant(merchantId) {
        return this.client.request({ method: 'GET', path: `/v1/store-profile/merchants/${encodeURIComponent(merchantId)}/profiles`, auth: true });
    }
}
//# sourceMappingURL=store-profile.js.map